export class PreBakedAnimation extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
  }

  async playEffect(): Promise<void> {}
  stopEffect(): void {}
}

export class PreBakedVideoAnimation extends PreBakedAnimation {
  video!: Phaser.GameObjects.Video

  constructor(scene: Phaser.Scene, x: number, y: number, key: string) {
    super(scene, x, y)

    this.video = scene.add.video(x, y)
    this.video.load(key)

    scene.add.existing(this)
  }

  async playEffect(): Promise<void> {
    this.video.play(false)

    return new Promise((resolve) => {
      this.video.on('complete', () => {
        resolve()
      })
    })
  }
}
